import { FlagOutlined } from '@ant-design/icons'
import { Divider, Table } from 'antd'
import * as R from 'ramda'
import React from 'react'
import { connect } from 'react-redux'
import { firestoreConnect, isLoaded, withFirestore } from 'react-redux-firebase'
import { compose } from 'redux'

import { dataFromOrdered, findInOrdered, fsCollections } from '../../helpers/firestore'
import { playerResults } from '../../helpers/results'
import { resultColumns } from '../../shared/columns'
import { Flag } from '../countries'
import { spinnerWhileLoading } from '../higher-order/spinner'

import './PlayerResults.css'

const PlayerResults = ({
  playground,
  tournament,
  player,
  tournamentResultsMap,
  tournamentCombinedResultsMap,
}) => {
  const { holeResults, statistics } = playerResults(
    playground,
    tournament.rounds + (tournament.finalRound ? 1 : 0),
    player,
    tournamentResultsMap,
    tournamentCombinedResultsMap,
  ) as FIXME

  const columns = [
    {
      title: 'Lane',
      width: '3em',
      dataIndex: 'key',
      className: 'ResultsCol--lane',
      render: (value) => <span>{typeof value === 'number' ? `${value}.` : value}</span>,
    },
    ...R.range(1, tournament.rounds + 1).map((round) => ({
      title: round,
      dataIndex: round,
      width: '3em',
    })),
    ...(tournament.finalRound
      ? [{ title: <FlagOutlined />, dataIndex: tournament.rounds + 1, width: '3em' }]
      : []),
    resultColumns.avg,
  ]

  const statisticsColumns = [{ dataIndex: 'key' }, { dataIndex: 'value', width: '100px' }]

  return (
    <div className="PlayerResults">
      <h2>
        <Flag iso2={player.nationality} /> <Divider type="vertical" />
        {`${player.firstName} ${player.lastName}`}
      </h2>
      <Table
        className="DetailedResults"
        bordered
        dataSource={holeResults}
        columns={columns as FIXME}
        pagination={false}
        size="small"
      />
      <Table
        className="PlayerStatistics"
        bordered
        showHeader={false}
        dataSource={statistics}
        columns={statisticsColumns}
        pagination={false}
        size="small"
      />
    </div>
  )
}

export default compose<FIXME>(
  withFirestore,
  firestoreConnect<FIXME>(({ tenant, tournamentId }) => [
    { collection: fsCollections.tournaments(tenant), doc: tournamentId },
    { collection: fsCollections.tournamentPlayers(tenant, tournamentId) },
    { collection: fsCollections.tournamentResults(tenant, tournamentId) },
    { collection: fsCollections.tournamentCombinedResults(tenant, tournamentId) },
  ]),
  connect(({ firestore }: FIXME, { tenant, tournamentId, playerId }: FIXME) => {
    const tournamentResults =
      firestore.ordered[fsCollections.tournamentResults(tenant, tournamentId)]

    const tournamentCombinedResults =
      firestore.ordered[fsCollections.tournamentCombinedResults(tenant, tournamentId)]

    return {
      tournament: findInOrdered(firestore.ordered[fsCollections.tournaments(tenant)], tournamentId),
      player: findInOrdered(
        firestore.ordered[fsCollections.tournamentPlayers(tenant, tournamentId)],
        playerId,
      ),
      tournamentResultsMap: R.isNil(tournamentResults)
        ? undefined
        : dataFromOrdered(tournamentResults.filter((result) => result.id.startsWith(playerId))),

      tournamentCombinedResultsMap: R.isNil(tournamentCombinedResults)
        ? undefined
        : dataFromOrdered(
            tournamentCombinedResults.filter((result) => result.id.startsWith(playerId)),
          ),
    }
  }),
  spinnerWhileLoading(
    (props) =>
      !isLoaded(
        props.tournament,
        props.player,
        props.tournamentResultsMap,
        props.tournamentCombinedResultsMap,
      ),
  ),
)(PlayerResults)



// WEBPACK FOOTER //
// ./src/components/tournament/PlayerResults.tsx